// extracted by mini-css-extract-plugin
export default {"hidden":"Signup__hidden--VqBJa","container":"Signup__container--qLAm6","wrapper":"Signup__wrapper--bFkY0","personIcon":"Signup__personIcon--QYhbf"};